<style lang="scss">
  @import '../resources/scss/objectives.scss';
</style>

<script lang="ts">
  import type Objectives from '../api/rest/directus-cms/about/models/Objectives'
  import ObjectiveTile from './ObjectiveTile.svelte'

  export let objectives: Objectives
</script>

{#if objectives}
  <section id="objectives">
    <div class="container-xxl bg-white py-section">
      <div class="row bg-white">
        <div class="col-12 col-xl-7 pb-5 pb-xl-0">
          <h1 class="text-primary-orange title">{objectives.title}</h1>
          <h4 class="text-neutral-b">{@html objectives.message}</h4>
          <div class="pt-5 d-flex flex-wrap objectives-container">
            {#each objectives.items as item}
              <ObjectiveTile objective={item} />
            {/each}
          </div>
        </div>
        <div
          class="col-12 col-xl-5 d-flex justify-content-center align-items-end pt-lg-5"
        >
          <img class="objective-image" src={objectives.image?.fullUrl} alt="objectives" />
        </div>
      </div>
    </div>
  </section>
{/if}
